export default "__VITE_ASSET__CJ3vx$2w__"